(function () {
  'use strict';

  /* @ngdoc object
   * @name helpers.zipcode
   * @description
   *
   */
  angular
    .module('helpers.zipcode', [
      'ui.router'
    ]);
}());
